import React, { useContext, useState } from "react";
import { Card, Layout } from "@shopify/polaris";

// import helper
import { storageHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";

// import components
import { SingleColumnLayout } from "layout/private/components";
import { Banner, SkeletonList } from "lib/components";
import { QuickAction, QuickReport } from "app/reports";
import { BalanceMajor, ExportMinor } from "@shopify/polaris-icons";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";

// import subFeature
import PaymentList from "app/payments/modules/generic/list/list";
import ProviderExportPayment from "app/payments/modules/provider/features/export/export";

const ProviderPaymentList = () => {
  const { cms, history, isLoading } = useContext(PrivateContext);

  const [banner, setBanner] = useState({
    isOpen: false,
    title: "",
    status: "",
    message: "",
  });
  const [isOpenModal, setModal] = useState(false);

  const linkData = [
    {
      action: () => setModal(!isOpenModal),
      caption: cms("label.caption"),
      id: "exportPayment",
      icon: ExportMinor,
      label: cms("label.export"),
      primary: true,
      shop: true,
    },
    {
      action: () => history.push("/payments/credit-note"),
      caption: cms("label.access"),
      icon: BalanceMajor,
      id: "creditNoteBalance",
      label: cms("label.balance"),
    },
  ];

  const toggleBanner = () => {
    setBanner({ isOpen: false });
  };
  const getComponent = () => {
    if (isLoading) {
      return <SkeletonList />;
    }
    return (
      <>
        <Layout>
          {banner.isOpen && (
            <Layout.Section>
              <Banner status={banner.status} isOpen={banner.isOpen} title={banner.title} onDismiss={toggleBanner} />
            </Layout.Section>
          )}
          <Layout.Section>
            <QuickReport />
            <QuickAction link={linkData} />
            <Card>
              <PaymentList setBanner={setBanner} />
            </Card>
          </Layout.Section>

          <ProviderExportPayment openModal={isOpenModal} setOpenModal={setModal} />
        </Layout>
      </>
    );
  };

  const currentUserRole = storageHelper.get("userRole");
  //  <TwoColumnLayout primary={getComponent(currentUserRole)} secondary={getSecondaryComponent()} />
  return <SingleColumnLayout primary={getComponent(currentUserRole)} />;
};

export default withFeature(withErrorBoundary(ProviderPaymentList), { feature: constant.PAYMENTS });
